var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ShareLink',{attrs:{"title":"Get signup link","link":_vm.formUrl,"filename":_vm.filename}})}
var staticRenderFns = []

export { render, staticRenderFns }